import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import iconCoding from './images/coding.svg';
import iconPlane from './images/flying.svg';
import iconParagliding from './images/paragliding.svg';

class Activities extends Component {
	render() {
		return (
			<div className='row' style={styles.container}>
				<div className='col-xs-12 col-sm-12 col-md-4 col-lg-4'>
					<div style={styles.activity}>
						<span style={styles.title}>coding</span>
						<Link to='/coding'>
							<img src={iconCoding} style={{width: 140, marginTop: 10}} alt='coding' />
						</Link>
					</div>
				</div>
				<div className='col-xs-12 col-sm-12 col-md-4 col-lg-4'>
					<div style={styles.activity}>
						<span style={styles.title}>flying</span>
						<Link to='/flying'>
							<img src={iconPlane} style={{width: 250, marginTop: 15}} alt='flying' />
						</Link>
					</div>
				</div>
				<div className='col-xs-12 col-sm-12 col-md-4 col-lg-4'>
					<div style={styles.activity}>
						<span style={styles.title}>paragliding</span>
						<Link to='/paragliding'>
							<img src={iconParagliding} style={{width: 120}} alt='paragliding' />
						</Link>
					</div>
				</div>
			</div>
		)
	}
}

export default Activities;

const styles = {
	container: {
		maxWidth: 900,
		margin: '0px auto'
	},
	activity: {
		padding: '15px 0px 35px 0px',
		textAlign: 'center'
	},
	title: {
		display: 'block',
		marginBottom: 15,
		fontFamily: 'Indie Flower',
		fontSize: '2em'
	}
}



// WEBPACK FOOTER //
// ./src/Activities.js